<template>
  <div id="cursor">
    <div class="cursor__bullet" ref="bullet">
      <div class="cursor__bullet__inner"></div>
    </div>
    <div class="cursor__text fs-12 tt-u" ref="text">
      <div class="cursor__text__inner">
        <span class="cursor__text__label ff-mono" data-cursor="watch">
          DISCOVER
        </span>
      </div>
    </div>
  </div>
</template>

<script setup>
const { $gsap: gsap, $mq } = useNuxtApp();

const bullet = ref(null);
const text = ref(null);

const showCursor = !$mq.isMobile && !$mq.isTablet;

onMounted(() => {
  nextTick(() => {
    if (!showCursor) return;

    const size = 10;

    const mouse = { x: 0, y: 0 };
    const bulletPos = { x: 0, y: 0 };
    const textPos = { x: 0, y: 0 };
    const prevTextY = { current: 0, previous: 0 };

    const bulletLerp = 0.08;
    const textLerp = 0.1;
    const rotationLerp = 0.12;

    const lerp = (start, end, factor) => start + (end - start) * factor;

    window.addEventListener('mousemove', e => {
      mouse.x = e.clientX - size / 2;
      mouse.y = e.clientY - size / 2;
    });

    const animate = () => {
      prevTextY.previous = prevTextY.current;
      prevTextY.current = textPos.y;

      bulletPos.x = lerp(bulletPos.x, mouse.x, bulletLerp);
      bulletPos.y = lerp(bulletPos.y, mouse.y, bulletLerp);

      textPos.x = lerp(textPos.x, mouse.x, textLerp);
      textPos.y = lerp(textPos.y, mouse.y, textLerp);

      const velocityY = textPos.y - prevTextY.previous;

      const rotationAngle = velocityY * -0.5;

      if (bullet.value) {
        bullet.value.style.setProperty('--x', bulletPos.x);
        bullet.value.style.setProperty('--y', bulletPos.y);
      }

      if (text.value) {
        text.value.style.setProperty('--x', textPos.x);
        text.value.style.setProperty('--y', textPos.y);
        text.value.style.setProperty('--rotation', rotationAngle);
      }

      requestAnimationFrame(animate);
    };

    animate();
  });
});
</script>

<style lang="scss" scoped>
#cursor {
  --size: 1rem;
  display: flex;
  left: 0;
  opacity: 1;
  overflow: hidden;
  pointer-events: none;
  position: fixed;
  top: 0;
  transform-origin: center;
  z-index: layer(cursor);
}

.cursor__bullet {
  width: var(--size);
  height: var(--size);
  aspect-ratio: 1;
  position: fixed;
  transform-origin: center;
  transform: translate3d(calc(var(--x) * 1px), calc(var(--y) * 1px), 0);
  left: 0;
  top: 0;
}

.cursor__bullet__inner {
  border-radius: var(--size);
  width: var(--size);
  height: var(--size);
  transition: transform 0.5s ease(outExpo);
  transform-origin: center;
}

.cursor__text {
  color: #fff;
  display: flex;
  flex-direction: column;
  left: 0;
  overflow: clip;
  padding: 1rem;
  position: fixed;
  top: -2rem;
  transform-origin: left center;
  width: fit-content;
  transform: translate3d(calc((var(--x) * 1px) - 45%), calc(var(--y) * 1px), 0)
    rotate(calc(var(--rotation) * 1deg));
}

.cursor__text__inner {
  display: flex;
  flex-direction: column;
  width: fit-content;
  height: 1em;
  overflow: hidden;
}

.cursor__text__label {
  transform: translateY(100%);
  transform-origin: top left;
  transition: transform 0.5s ease(outExpo) 0.2s;
}

[data-cursor='watch'] {
  body:has([data-cursor-project]:hover) & {
    transform: translateY(0%);
    transition: transform 0.5s ease(outExpo);
  }
}
</style>
